import { filesApi } from 'entities/file/api/filesApi';
import cloneDeep from 'lodash-es/cloneDeep';
import { makeAutoObservable, runInAction } from 'mobx';

export type UpdateFileParams = {
  id: string;
  name?: string;
  folder_id?: string;
  section_id?: string;
  file?: File;
  previewFile?: File | null;
};

export interface FileUpdatable {
  id: string;
  name: string;
  section_id: string | null;
  folder_id: string | null;
  preview_url?: string | null;
  source_preview_url?: string | null;
}

export class UpdateFileHelper {
  private _file: FileUpdatable;

  constructor(file: FileUpdatable) {
    this._file = file;
    makeAutoObservable(this);
  }

  public async update(params: UpdateFileParams) {
    try {
      const clone = cloneDeep(params);

      if (clone.folder_id) {
        delete clone.section_id;
      }
      if (clone.section_id) {
        delete clone.folder_id;
      }

      if (this._file.preview_url && params.previewFile === null) {
        await this._deletePreview();
      }

      const _data = await filesApi.update(this._file.id, clone);

      return _data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  private async _deletePreview() {
    try {
      await filesApi.deletePreview(this._file.id);

      runInAction(() => {
        if (this._file) {
          this._file.preview_url = null;
          this._file.source_preview_url = null;
        }
      });
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
